import { ExportFormat } from '@ecosystem/newron-client-lib';
import { capitalizeFirstLetter } from '@utils/StringUtils';
import { createImage, createMultiImagePowerPoint } from '../ExportChart';
import { getFilename } from '../ExportUtils';
import { CreateImagePowerPointParams, CreateMultiImagePowerPointParams, ExportChartArgs } from '../Model';
import { exportTable } from '../export-table/ExportTable';
import { ExportTrackingPageView } from '../export-tracking/ExportTracking';

export const exportDoubleBarChart = async ({
  exportFn,
  exportFormats,
  invokeExport,
  title,
  appliedCountry,
  appliedPg,
  data,
  factRevenue,
  timePeriod,
  comparisonTimePeriod,
  periodType,
  showPerformanceWithin,
  appliedFiltersText,
  selectedKpi,
  segmentBy,
  volume,
  multipleChartsExport,
  pageName,
  summaryData,
  pagesConfig,
  loadedProductGroups,
}: ExportChartArgs): Promise<void> => {
  if (exportFormats.includes(ExportFormat.Xlsx)) {
    const exportOptions: ExportChartArgs = {
      exportFn: exportFn,
      invokeExport: invokeExport,
      exportFormats: exportFormats,
      title: title,
      appliedCountry: appliedCountry,
      appliedPg: appliedPg,
      data: data,
      summaryData: summaryData,
      timePeriod: timePeriod,
      comparisonTimePeriod,
      factRevenue: factRevenue,
      periodType: periodType,
      appliedFiltersText: appliedFiltersText,
      selectedKpi: selectedKpi,
      pageName: pageName,
      pagesConfig: pagesConfig,
      volume: volume,
      showPerformanceWithin: showPerformanceWithin,
      segmentBy: '',
      loadedProductGroups,
    };

    await exportTable(exportOptions);
  }

  const filename = getFilename({
    title,
    appliedCountry,
    appliedPg,
    timeframe: timePeriod,
    comparisonTimePeriod,
    exportFormat: ExportFormat.Xlsx,
    selectedKpi: selectedKpi,
    pageName: pageName,
  });

  if (exportFormats.includes(ExportFormat.Pptx) && multipleChartsExport) {
    const chartTitles = Array.from({ length: multipleChartsExport.length }, () => title);
    const chartSubTitles = Array.from({ length: multipleChartsExport.length }, () =>
      capitalizeFirstLetter(selectedKpi.label),
    );
    const methodParam: CreateMultiImagePowerPointParams = {
      filename: filename,
      exportFn: exportFn,
      appliedCountry: appliedCountry,
      appliedPg: appliedPg,
      timePeriod: timePeriod,
      comparisonTimePeriod: comparisonTimePeriod,
      periodType: periodType,
      showPerformanceWithin: showPerformanceWithin,
      appliedFiltersText: appliedFiltersText,
      selectedKpi: selectedKpi,
      segmentBy: segmentBy,
      chartTitles: chartTitles,
      chartSubTitles: chartSubTitles,
      multipleChartsExport: multipleChartsExport,
      pageName: pageName,
      pagesConfig: pagesConfig,
      loadedProductGroups,
    };

    await createMultiImagePowerPoint(methodParam);
  }

  if (exportFormats.includes(ExportFormat.Png)) {
    const methodParam: CreateImagePowerPointParams = {
      filename: filename,
      exportFn: exportFn,
      appliedCountry: appliedCountry,
      appliedPg: appliedPg,
      timePeriod: timePeriod,
      comparisonTimePeriod: comparisonTimePeriod,
      periodType: periodType,
      showPerformanceWithin: showPerformanceWithin,
      appliedFiltersText: appliedFiltersText,
      invokeExport: invokeExport,
      selectedKpi: selectedKpi,
      segmentBy: segmentBy,
      title: title,
      subTitle: selectedKpi.label,
      pageName: pageName,
      pageView: ExportTrackingPageView.BarChart,
      pagesConfig: pagesConfig,
      loadedProductGroups,
    };
    await createImage(methodParam, title);
  }
};
